import { DealersModel } from '@models/retailer/dealers.model';
import { createAction, props } from '@ngrx/store';

export const makeMyRetailer = createAction('[Retailer] Make My Retailer', props<{ myRetailer?: DealersModel }>());
export const clearMyRetailer = createAction('[Retailer] Clear My Retailer');
